export default __webpack_public_path__ + "static/media/postgres.f55f39a3.png";